<template>
  <div class="startingPage">
    <div class="containerView">
      <div
        class="item_"
        v-for="item in pageData.list"
        :key="item"
        @click="pageJump(item.url)"
      >
        <div class="backImg">
          <img :src="item.img" />
        </div>
        <div class="title_">
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- <div class="dataList">
      <div class="list" v-for="(item, index) in numsData" :key="index">
        <div>{{ item.value }}</div>
        <div>{{ item.name }}</div>
      </div>
      <div style="width:150px;height:0;"></div>
      <div style="width:150px;height:0;"></div>
      <div style="width:150px;height:0;"></div>
      <div style="width:150px;height:0;"></div>
    </div>
    <div class="content">
      <div class="banner">
        <img
          src="https://assets.manutd.com/AssetPicker/images/0/0/12/121/817592/19-180R_mufc_team_shot35330_v1.5_201910081030450971571315427930_xlarge.jpg"
        />
      </div>
      <div class="banner">
        <img
          src="https://assets.manutd.com/AssetPicker/images/0/0/15/180/1029141/Carington_Training_Ground_4_202109211119451111640088503067_large.webp
"
        />
      </div>
      <div class="dynamic">
        <div class="title">产品动态</div>
        <div class="list">
          <div>教师培养策略的思考与实践</div>
          <div>1993年04月09日</div>
        </div>
        <div class="list">
          <div>需求驱动的高中生涯课程校本化设计与实施</div>
          <div>1993年04月09日</div>
        </div>
        <div class="list">
          <div>选课走班背景下教师的角色</div>
          <div>1993年04月09日</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { reactive } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "startingPage",
  setup() {
    const router = useRouter();
    let pageData = reactive({
      list: [
        {
          img: require("../assets/images/startingPage1.png"),
          name: "版权登记申请",
          url: "contentChain",
        },
        {
          img: require("../assets/images/startingPage2.png"),
          name: "版权管理",
          url: "homeArticleManagement",
        },
        {
          img: require("../assets/images/startingPage3.png"),
          name: "订单管理",
          url: "orderManagement",
        },
      ],
    });
    function pageJump(e) {
      router.push({
        path:e,
      });
    }
    return {
      pageData,
      pageJump,
    };
  },
  // data() {
  //   return {
  //     numsData: [
  //       {
  //         name: "文章总和",
  //         value: "323602",
  //       },
  //       {
  //         name: "累计使用量",
  //         value: "323602",
  //       },
  //       {
  //         name: "累计使用量",
  //         value: "323602",
  //       },
  //       {
  //         name: "文章总和",
  //         value: "323602",
  //       }
  //     ],
  //   };
  // },
};
</script>
<style lang="scss" scope>
.startingPage {
  .containerView {
    width: 1050px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item_ {
      width: 334px;
      height: 400px;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      // align-items: center;
      .title_ {
        margin-top: 24px;
        text-align: center;
        font-size: 20px;
        font-family: AlibabaPuHuiTiM;
        color: #008aea;
      }
      .backImg {
        width: 334px;
        height: 280px;
        img {
          width: 100%;
        }
      }
    }
  }
  // .content {
  //   width: 240px;
  //   margin-left: 24px;
  //   .dynamic {
  //     width: 100%;
  //     padding: 20px;
  //     box-sizing: border-box;
  //     background: #fff;
  //     box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  //     border-radius: 4px;
  //     .list {
  //       margin-top: 16px;
  //       div {
  //         font-family: AlibabaPuHuiTiR;
  //       }
  //       div:nth-of-type(1) {
  //         font-size: 15px;
  //         color: #606266;
  //         margin-bottom: 6px;
  //       }
  //       div:nth-of-type(2) {
  //         font-size: 12px;
  //         color: #909399;
  //       }
  //     }
  //     .title {
  //       font-size: 15px;
  //       font-family: AlibabaPuHuiTiM;
  //       color: #303133;
  //       margin-bottom: 2px;
  //     }
  //   }
  //   .banner {
  //     width: 100%;
  //     border-radius: 4px;
  //     overflow: hidden;
  //     margin-bottom: 10px;
  //     img {
  //       width: 100%;
  //     }
  //   }
  // }
  // .dataList {
  //   width: 740px;
  //   display: flex;
  //   justify-content: space-between;
  //   flex-wrap: wrap;
  //   .list {
  //     width: 150px;
  //     height: 80px;
  //     background: #ffffff;
  //     box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  //     border-radius: 8px;
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: center;
  //     align-items: center;
  //     font-family: AlibabaPuHuiTiM;
  //     font-weight: 800;
  //     div:nth-of-type(1) {
  //       font-size: 18px;
  //       color: #303133;
  //     }
  //     div:nth-of-type(2) {
  //       font-size: 12px;
  //       color: #909399;
  //     }
  //   }
  // }
}
</style>
